import { NumberInput, minValue, required } from "react-admin";
import { integerValidator } from "utils/validations";
import { DisciplineInput, GridItem, HoursInput } from "./Partials";

const FacultativeDisciplineFields = () => (
  <>
    <DisciplineInput />

    <HoursInput
      source="lecturesAuditoriumOccupancy"
      label="Общ брой часове лекции"
      md={3}
      isRequired
    />
    <HoursInput
      source="seminarExercisesAuditoriumOccupancy"
      label="Общ брой часове СУ"
      md={3}
    />
    <HoursInput
      source="laboratoryExercisesAuditoriumOccupancy"
      label="Общ брой часове ЛУ"
      md={3}
    />
    <HoursInput
      source="practicalExercisesAuditoriumOccupancy"
      label="Общ брой часове ПУ"
      md={3}
    />
    <HoursInput
      source="extracurricularActivities"
      label="Извънаудиторна заетост"
      md={6}
      isRequired
    />
    <GridItem md={6}>
      <NumberInput
        source="order"
        label="Ред на дисциплина в учебния план"
        fullWidth
        min={1}
        step={1}
        validate={[required("Полето е задължително."), minValue(1, "Минималната стойност е 1."), integerValidator]}
        onWheel={e => e.target.blur()}
      />
    </GridItem>
  </>
);

export default FacultativeDisciplineFields;
